import { render, staticRenderFns } from "./shouYou.vue?vue&type=template&id=6947a284&scoped=true&"
import script from "./shouYou.vue?vue&type=script&lang=js&"
export * from "./shouYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6947a284",
  null
  
)

export default component.exports